import { Box, Grid } from "@mui/material";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { LangContext } from "../../contexts/LangContext";
import { api } from "../../services/api";
import ButtonSave from "../buttonSave";
import CardSys from "../cardSys";
import CloseButton from "../generic/closeButton";
import InputNameGroup from "../generic/inputNameGroup";
import SubTitlePages from "../generic/subTitlePages";
import SelectGroups from "../selectGroups";

export default function CreateModules({ handleBack, updateTable, handleEdit }) {
  const [groupSelected, setGroupSelected] = useState("");
  const [name, setName] = useState("");
  const { user } = useContext(AuthContext);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const { lang } = useContext(LangContext);

  const permissionGroup = [];
  user?.permission?.map((el) => {
    if (el.name == "Grupos de permissão") {
      permissionGroup.push(...el.permission);
    }
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleLoading(true);
    try {
      const { data } = await api({
        method: "POST",
        url: "/group",
        data: {
          name,
          groupSelected,
        },
      });
      const {id} = data
      handleToast(true, data.toast, data.message);
      handleBack()
      handleEdit({id, name, visible: true})
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable()

  };

  return (
    <>
      <CardSys>
        <Grid
          item
          sx={{ display: "flex" }}
          justifyContent="space-between"
          alignItems="center"
          xs={12}
        >
          <SubTitlePages sx={{ display: "flex" }}>
            <SubTitlePages sx={{ fontWeight: "bold", marginRight: "4px" }}>
              Criar perfil de acesso
            </SubTitlePages>
          </SubTitlePages>
          <Box>
            {!!permissionGroup.find((el) => el.name == "Criar") ? (
              <ButtonSave onClick={handleSubmit}>Salvar</ButtonSave>
            ) : null}
          </Box>
          <CloseButton onClick={handleBack}></CloseButton>
        </Grid>
        <Box component="form" onSubmit={handleSubmit} sx={{ padding: "8px" }}>
          <Grid container sx={{ marginTop: "8px" }}>
            <InputNameGroup
              value={name}
              onChange={({ target }) => setName(target.value)}
              sx={{ background: "transparent" }}
            ></InputNameGroup>
          </Grid>
          <Grid container sx={{ marginTop: "8px" }}>
            <SelectGroups
              handleSelected={(id) => setGroupSelected(id)}
            ></SelectGroups>
          </Grid>
          {/* {!user?.id_client ? (
            <Grid container sx={{ marginTop: "8px" }}>
              <SelectEnterprise
                handleSelected={(id) => setEnterpriseSelected(id)}
              ></SelectEnterprise>
            </Grid>
          ) : null} */}
        </Box>
      </CardSys>
    </>
  );
}
